<script>
import FundraiserTeamLayoutModern from '@/pages/fundraisers/public/layouts/team/FundraiserTeamLayoutModern.vue'
export default {
  name: 'TeamPublicPage',
  components: { FundraiserTeamLayoutModern },
  mixins:[],
  props: {
    teamId: {
      type: Number,
      required: true
    },
    fundraiserId: {
      type: Number,
      required: true
    }
  },
  computed: {
    layout() {
      return 'fundraiser-team-layout-modern'
    }
  }
}
</script>

<template>
  <component :is="layout" v-if="teamId && fundraiserId" :fundraiser-id="fundraiserId" :team-id="teamId" />
</template>

<style scoped>

</style>
